import type { ReactElement } from 'react';
import { Logo, LogoWrapper } from './styles';

function BalanceLayoutHeader(): ReactElement {
  return (
    <LogoWrapper to="/payment-history">
      <Logo src="/assets/images/trybe-logo.svg" alt="Logo da Trybe" />
    </LogoWrapper>
  );
}

export default BalanceLayoutHeader;
